import { ProgramType, IMealCountKey } from '@/models';

export class MealCountVersion implements IMealCountKey {
  constructor(
    public trackingId: string = '',
    public siteId: number = 0,
    public programId: string = ProgramType.SFSP,
    public mealTypeId: string = '',
    public mealServiceDate: string = '',
    public versionDateTimeUtc: string = '',
    public isNonCongregate: boolean = false,
    public providedDays: number = 0
  ) {
  }
}
